import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Breadcrumbs, H5 } from '../../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Input } from 'reactstrap';
import DataTable from '../../../Common/DataTable';
import { Edit } from 'react-feather';
import DictionaryDataModal from './DictionaryDataModal';
import { fetchTableData } from '../../../../Api/ApiMethods';

const DictionaryVariables = () => {
    const [data, setData] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [search, setSearch] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDictionary, setSelectedDictionary] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const PAGE_SIZE = 1000;
    const dictionaryApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/dictionary';

    const applyFilter = useCallback((items, term) => {
        const normalized = term.trim().toLocaleLowerCase('tr-TR');
        if (!normalized) return items;
        return items.filter(item => (item.title || '').toLocaleLowerCase('tr-TR').includes(normalized));
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        setSearch(event.target.value);
    };

    const loadDictionaries = useCallback(async () => {
        setIsLoading(true);
        try {
            await fetchTableData({
                apiEndpoint: dictionaryApiUrl,
                page: 1,
                pageSize: PAGE_SIZE,
                setDataCallback: (items) => {
                    setFullData(items);
                    setData(items);
                },
            });
        } finally {
            setIsLoading(false);
        }
    }, [dictionaryApiUrl, PAGE_SIZE]);

    useEffect(() => {
        loadDictionaries();
    }, [loadDictionaries]);

    useEffect(() => {
        setData(applyFilter(fullData, search));
    }, [search, fullData, applyFilter]);

    const openModifyModal = (dictionary) => {
        setSelectedDictionary(dictionary);
        setModalOpen(true);
    };

    const columns = [
        { name: 'Parametre Adı', selector: row => row.title, sortable: true, grow: 2 },
        { name: 'Değer', selector: row => row.value != null ? row.value : '-', sortable: true },
        {
            name: 'Düzenle',
            cell: (row) => (
                <div
                    className="btn btn-outline-warning"
                    onClick={() => openModifyModal(row)}
                >
                    <Edit size={18} />
                </div>
            ),
            ignoreRowClick: true,
            right: true,
            button: true
        },
    ];

    return (
        <>
            <Breadcrumbs parent='Hazır Girdi Alanları' title='Sabit Değişkenler' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Sabit Değişkenler</H5>
                                <span>Sistem genelinde kullanılan sabit değişkenler aşağıda listelenmektedir. Sadece değerleri düzenlenebilir.</span>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex justify-content-end align-items-center w-100 file-content flex-wrap">
                                    <div className='form-inline me-2 mt-3 p-0 custom-responsive-width'>
                                        <div className='mb-0 form-group d-flex align-items-center border rounded px-2' style={{ height: '35px' }}>
                                            <i className='fa fa-search text-muted'></i>
                                            <Input
                                                type="text"
                                                placeholder="Ara.."
                                                value={search}
                                                onChange={(e) => handleSearch(e)}
                                                className="border-0 ms-2 shadow-none"
                                                style={{ height: '33px', flexGrow: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ height: "40px" }}></div>

                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        pagination
                                        progressPending={isLoading}
                                        progressComponent={<div className="py-4 text-center">Yükleniyor...</div>}
                                        noDataComponent={isLoading ? null : <div className="p-4 text-center">Sabit değişken bulunamadı.</div>}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <DictionaryDataModal
                apiEndpoint={dictionaryApiUrl}
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                selectedDictionary={selectedDictionary}
                refreshData={loadDictionaries}
            />
        </>
    );
};

export default DictionaryVariables;
